import "./social.scss";
import lisbon from "./assets/lisbon.gif";
import prof from "./assets/prof.gif";
import title from "./assets/title.png";
import tweets from "./assets/tweets.png";
import arturo from "./assets/arturo.mp4";
import pencil from "./assets/pencil.mp4";
import puta from "./assets/puta.mp4";
import { fade, childFade, rise } from "../fade.js";
import { motion } from "framer-motion";

const Social = () => {
  return (
    <section class="section social">
      <motion.img
        src={title}
        alt="creating shareable content for Social media"
        className="title"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      />
      <motion.p
        className="copy"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        We created content around characters fans were talking about the most.
      </motion.p>
      <motion.div
        className="tweets-wrapper"
        variants={rise}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <img src={tweets} alt="Tweets" className="tweets" />
        <p className="disclaimer">Translated for context</p>
      </motion.div>
      <motion.p
        className="copy"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        One piece of content allowed fans to vote for the label that was most
        apt for each character.{" "}
      </motion.p>
      <motion.div
        className="banners"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <motion.div className="banner-item" variants={childFade} key="LISB">
          <img src={lisbon} alt="Lisbon" />
          <h3>
            Friend or <span>Foe?</span>
          </h3>
        </motion.div>
        <motion.div className="banner-item" variants={childFade} key="PROF">
          <img src={prof} alt="Professor" />
          <h3>
            Crazy or <span>Genius?</span>
          </h3>
        </motion.div>
      </motion.div>
      <motion.p
        className="copy"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        Another series served as recaps of the past four seasons through the
        lens of each character.
      </motion.p>
      <motion.div
        className="closely"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <motion.div className="item" variants={childFade} key="PUTA">
          <video controls>
            <source src={puta} type="video/mp4" />
          </video>
          <h3>
            The <span>"PUTA"</span> counter
          </h3>
        </motion.div>
        <motion.div className="item" variants={childFade} key="ART">
          <video controls>
            <source src={arturo} type="video/mp4" />
          </video>
          <h3>
            reasons to hate <span>arturo</span>{" "}
          </h3>
        </motion.div>
        <motion.div className="item" variants={childFade} key="PEN">
          <video controls>
            <source src={pencil} type="video/mp4" />
          </video>
          <h3>
            The <span>"pencil bun"</span> counter
          </h3>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Social;
